export default __webpack_public_path__ + "static/media/WalkingJoy.f873b4685e7ca78e442a23ecc7d3e8bb.webp";